import { engageAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { xeroAPIUrls } from '../data';

type OAuthStartResponse = {
  authUrl: string;
  already_connected?: boolean;
};

type OAuthCompletionResponse = {
  message: string;
  data: any;
};

type Response = OAuthStartResponse | OAuthCompletionResponse;

export type GetXeroInvoiceConnect = {
  params?: {
    code?: string;
    company_id?: string;
  };
  response: Response;
};

export const getXeroInvoiceConnect = withLogger(
  async (params?: GetXeroInvoiceConnect['params']): Promise<Response> => {
    const response = await engageAxiosClient.get<Response>(
      xeroAPIUrls.xeroConnect,
      {
        params: {
          code: params?.code,
          company_id: params?.company_id,
        },
      },
    );

    return response.data;
  },
);
